import { trackEvent } from "./trackEvent";
import "./modules/link";
import "./modules/actionButton";
import "./modules/accordion";
import "./modules/tab";
import "./modules/pageData";

/* eslint-disable */
window.dataLayer = window.dataLayer || [];
window.addEventListener("track-event", ({ detail }) => trackEvent(detail));